import { render } from "./kpi.vue?vue&type=template&id=74980b41"
import script from "./kpi.vue?vue&type=script&lang=js"
export * from "./kpi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__